// extracted by mini-css-extract-plugin
export var dropdownButton = "_1s-0";
export var fullWidthDropdownButton = "_1s-1";
export var icon = "_1s-3";
export var iconPlaceholder = "_1s-2";
export var menuItemRow = "_1s-5";
export var shortcutContainer = "_1s-4";